import api from "./Api";

class PedidoPagamentoService {
  GetPedidoPagamento(payload) {
    return api.get("/v1/pedidoPagamento/" + payload).then((response) => {
      return response.data;
    });
  }

  PostPedidoPagamento(payload) {
    return api.post("/v1/pedidoPagamento/", payload).then((response) => {
      return response.data;
    });
  }

  PutPedidoPagamento(payload) {
    return api.put("/v1/pedidoPagamento/", payload).then((response) => {
      return response.data;
    });
  }

  DeletePedidoPagamento(payload) {
    return api.delete("/v1/pedidoPagamento/" + payload).then((response) => {
      return response.data;
    });
  }

  GetPedidoPagamentoOData(payload) {
    return api.get("/OData/PedidoPagamento" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new PedidoPagamentoService();
